import { createContext, useState, ReactNode, useCallback } from "react";

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

export interface BreadcrumbContextType {
  breadcrumbs: BreadcrumbItem[];
  setBreadcrumbs: (breadcrumbs: BreadcrumbItem[]) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(
  undefined
);

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([
    { label: "IDAIS", path: "/" },
  ]);

  const setBreadcrumbsWithRoot = useCallback(
    (newBreadcrumbs: BreadcrumbItem[]) => {
      const breadcrumbsWithRoot = [
        { label: "IDAIS", path: "/" },
        ...newBreadcrumbs,
      ];
      setBreadcrumbs(breadcrumbsWithRoot);
    },
    []
  );

  return (
    <BreadcrumbContext.Provider
      value={{ breadcrumbs, setBreadcrumbs: setBreadcrumbsWithRoot }}
    >
      {children}
    </BreadcrumbContext.Provider>
  );
}

export default BreadcrumbContext;
